export enum UserStatusEnum {
  ACTIVE = 'ATIVO',
  INACTIVE = 'INATIVO',
  REGISTER_ENABLED = 'REGISTRO LIBERADO',
  REGISTER_BLOCKED = 'REGISTRO BLOQUEADO',
}

export enum ValidityStatusEnum {
  ACTIVE = 'ATIVO',
  INACTIVE = 'INATIVO',
}


export enum InstitutionStatusEnum {
  REGISTER_ACTIVE = 'CADASTRO ATIVO',
  REGISTER_INACTIVE = 'CADASTRO INATIVO',
  REGISTER_BLOCKED = 'CADASTRO BLOQUEADO',
  REGISTER_ENABLED = 'CADASTRO DESBLOQUEADO',
}

export enum InstitutionContactTypeEnum {
  CELLPHONE = 'CELLPHONE',
}

export const municipios = [
  'Cuiabá',
  'Várzea Grande',
  'Rondonópolis',
  'Sinop',
  'Tangará da Serra',
  'Lucas do Rio Verde',
  'Barra do Garças',
];

export const permissoes = [
  'Administrador',
  'Representante Legal Estadual',
  'Gerente Estadual',
  'Operador Estadual',
  'Conselheiro Estadual',
];
